/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PickDto } from '../../models/pick-dto';

export interface PickControllerFindByUserId$Params {
  userId: string;

/**
 * 제외할 픽 ID
 */
  excludePickId?: string;
}

export function pickControllerFindByUserId(http: HttpClient, rootUrl: string, params: PickControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
  const rb = new RequestBuilder(rootUrl, pickControllerFindByUserId.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.query('excludePickId', params.excludePickId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PickDto>>;
    })
  );
}

pickControllerFindByUserId.PATH = '/api/picks/user/{userId}';
